// tslint:disable: no-invalid-template-strings
import { ActionType, createAction } from 'typesafe-actions';
import { IListObjectStore } from '../../_common/type';
import {
    EAnnex6RecordCode,
    TAnnex6BackendRecord,
    TAnnex6HistoryFilters,
} from './@types';

enum EAnnex6Constants {
    FEATURE = '@annex-6',
    // API = '/marpol-annex6',
    API = '/api/marpol/all',
}
enum EAnnex6Actions {
    HISTORY_LOAD = '@annex-6/:history-load',
    
    HISTORY_SET = '@annex-6/${history}/set',

    GOTO_DASHBOARD = '@annex-6/-->dashboard',
    GOTO_OPERATION_DASHBOARD = '@annex-6/-->operation-dashboard',
    GOTO_SELECTED_OPERATION = '@annex-6/-->selected-operation',
    GOTO_HISTORY = '@annex-6/-->history',

    SET_FILTER = '@annex-6/:set-filter',
}

const annex6Actions = {
    commands: {
        historyLoad: createAction(
            EAnnex6Actions.HISTORY_LOAD,
            (providedFilters: TAnnex6HistoryFilters) => ({ providedFilters })
        )(),
    },
    document: {
        historySet: createAction(
            EAnnex6Actions.HISTORY_SET,
            (history: IListObjectStore<TAnnex6BackendRecord>) => ({ history })
        )(),
        setFilter: createAction(EAnnex6Actions.SET_FILTER, (filter: any) => ({
            filter,
        }))(),
    },
    routes: {
        gotoDashboard: createAction(EAnnex6Actions.GOTO_DASHBOARD)(),
        gotoOperationDashboard: createAction(
            EAnnex6Actions.GOTO_OPERATION_DASHBOARD
        )(),
        gotoSelectedOperation: createAction(
            EAnnex6Actions.GOTO_SELECTED_OPERATION,
            (operationCode: EAnnex6RecordCode) => ({ operationCode })
        )(),
        gotoHistory: createAction(EAnnex6Actions.GOTO_HISTORY)(),
    },
    events: {},
};

export type TANNEX6Actions = ActionType<typeof annex6Actions>;
export default annex6Actions;
export { EAnnex6Constants, EAnnex6Actions };
